// src/context/brandVoice/widgets/listStyles.js — the look every Brand Voice list editor shares
// (filled inputs, a square remove button, an accent "+ Aggiungi" link). Tokens only.
// Moved out of PairListEditor.jsx in v186.
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../../constants/theme.js';

export const ROW = { display: 'flex', alignItems: 'flex-start', gap: 10, flexWrap: 'wrap' };
export const INPUT = (invalid) => ({
  boxSizing: 'border-box', minHeight: 46, padding: '12px 14px',
  background: COLORS.field, border: `1px solid ${invalid ? SEMANTIC.errore.fg : 'transparent'}`,
  borderRadius: RADII.control, fontFamily: FONT_SANS, fontSize: 14, lineHeight: '20px', color: COLORS.ink,
});
export const REMOVE = (disabled) => ({
  boxSizing: 'border-box', width: 46, height: 46, flex: '0 0 46px',
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  background: COLORS.surface, border: `1px solid ${COLORS.borderStrong}`, borderRadius: RADII.control,
  color: disabled ? COLORS.textTertiary : COLORS.textSecondary, cursor: disabled ? 'not-allowed' : 'pointer',
});
// v200 (claims): the add button as a bare icon on the last row, in the REMOVE button's 46px cell.
export const ADD_ICON = (disabled) => ({
  boxSizing: 'border-box', width: 46, height: 46, flex: '0 0 46px', padding: 0,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none',
  color: disabled ? COLORS.textTertiary : COLORS.ink, cursor: disabled ? 'not-allowed' : 'pointer',
});
export const ADD = (disabled) => ({
  padding: 0, border: 'none', background: 'transparent', fontFamily: FONT_SANS, fontSize: 13, fontWeight: 600,
  color: disabled ? COLORS.textTertiary : COLORS.accent, cursor: disabled ? 'not-allowed' : 'pointer',
});
export const EMPTY = { margin: 0, fontSize: 13, color: COLORS.textTertiary };
